// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HeaderList_header__N7jbf {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 40px;
}

@media (max-width: 768px) {
  .HeaderList_header__N7jbf {
    flex-direction: column;
    align-items: stretch;
    gap: 16px;
    margin-bottom: 24px;
  }
}

.HeaderList_titleWrap__Yb3y\\+ {
  display: flex;
  align-items: center;
}

.HeaderList_title__nfYZL {
  font-weight: 700;
  font-family: BebasNeue;
  color: var(--orange);
  font-size: 30px;
  line-height: 25px;
}

.HeaderList_backWrap__OefAf {
  display: flex;
  width: 32px;
  height: 32px;
  align-items: center;
  justify-content: center;
  background-color: var(--orange);
  border-radius: 100%;
  color: white;
  margin-right: 15px;
}
`, "",{"version":3,"sources":["webpack://./src/components/styles/HeaderList.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE;IACE,sBAAsB;IACtB,oBAAoB;IACpB,SAAS;IACT,mBAAmB;EACrB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,oBAAoB;EACpB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;AACpB","sourcesContent":[".header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 40px;\n}\n\n@media (max-width: 768px) {\n  .header {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 16px;\n    margin-bottom: 24px;\n  }\n}\n\n.titleWrap {\n  display: flex;\n  align-items: center;\n}\n\n.title {\n  font-weight: 700;\n  font-family: BebasNeue;\n  color: var(--orange);\n  font-size: 30px;\n  line-height: 25px;\n}\n\n.backWrap {\n  display: flex;\n  width: 32px;\n  height: 32px;\n  align-items: center;\n  justify-content: center;\n  background-color: var(--orange);\n  border-radius: 100%;\n  color: white;\n  margin-right: 15px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `HeaderList_header__N7jbf`,
	"titleWrap": `HeaderList_titleWrap__Yb3y+`,
	"title": `HeaderList_title__nfYZL`,
	"backWrap": `HeaderList_backWrap__OefAf`
};
export default ___CSS_LOADER_EXPORT___;
